import React from 'react';
import ExpandIconSvg from './Expand_icon.svg';

const ExpandIcon = (props) => <img src={ExpandIconSvg} alt="Open" {...props} />;

export default ExpandIcon;
